<section class="edp-languages">
    <header class="d-flex flex-column">
        <button (click)="close()" class="btn btn-close" type="button">
            <i class="icon icon-edponline-Bop-078 icon-2x rotate-180" aria-hidden="true"></i>
        </button>
        <h1>{{ "pt.edp.edponline.language.title" | translate }}</h1>
    </header>
    <div class="container-languages">
        <ng-container *ngFor="let item of languages">
            <div class="language-item" [ngClass]="{ selected: item.language_key === userLanguage }"
                (click)="selectLanguage(item)">
                {{ item.language_label }}
            </div>
        </ng-container>
    </div>
</section>